import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import "swiper/css";
import "swiper/css/navigation";

const Testimonial = () => {
  return (
    <>
      <h2 className="text-center mt-2">Testimonial</h2>

      <div className="container-fluid mt-5">
        <div className="container">
          <div className="row">

            {/* LEFT SIDE */}
            <div className="col-md-7 py-5 pe-md-5">

              <h6 className="text-primary text-uppercase mb-3 pt-5">
                Testimonial
              </h6>

              <h1 className="mb-4 section-title">
                What Our Clients Say
              </h1>

              {/* WRAPPER */}
              <div className="testimonial-wrapper">

                {/* CUSTOM ARROWS */}
                <div className="test-prev">
                  <FaChevronLeft size={18} />
                </div>

                <div className="test-next">
                  <FaChevronRight size={18} />
                </div>

                <Swiper
                  modules={[Navigation, Autoplay]}
                  navigation={{
                    prevEl: ".test-prev",
                    nextEl: ".test-next",
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = ".test-prev";
                    swiper.params.navigation.nextEl = ".test-next";
                  }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  speed={1000}
                  spaceBetween={20}
                  slidesPerView={1}
                >

                  {/* TESTIMONIAL 1 */}
                  <SwiperSlide>
                    <div className="d-flex flex-column">

                      <div className="d-flex align-items-center mb-3">
                        <img
                          className="img-fluid rounded-circle"
                          src="/img/testimonial-1.jpg"
                          alt="Client"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                        />

                        <div className="ms-3">
                          <h5 className="mb-1">Client Name</h5>
                          <i>Profession</i>
                        </div>
                      </div>

                      <p>
                        Tempor at diam tempor sed. Sanctus dolor ipsum ut nonumy amet clita sea.
                      </p>

                    </div>
                  </SwiperSlide>

                  {/* TESTIMONIAL 2 */}
                  <SwiperSlide>
                    <div className="d-flex flex-column">

                      <div className="d-flex align-items-center mb-3">
                        <img
                          className="img-fluid rounded-circle"
                          src="/img/testimonial-2.jpg"
                          alt="Client"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                        />

                        <div className="ms-3">
                          <h5 className="mb-1">Client Name</h5>
                          <i>Profession</i>
                        </div>
                      </div>

                      <p>
                        Tempor at diam tempor sed. Sanctus dolor ipsum ut nonumy amet clita sea.
                      </p>

                    </div>
                  </SwiperSlide>

                </Swiper>

              </div>

            </div>

            {/* RIGHT IMAGE */}
            <div className="col-md-5">
              <div className="d-flex flex-column align-items-center justify-content-center h-100 overflow-hidden">
                <img
                  className="img-fluid h-100"
                  src="/img/testimonial.jpg"
                  alt="Testimonial"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* CUSTOM ARROW CSS */}
      <style>{`
        .testimonial-wrapper {
          position: relative;
        }

        .test-prev,
        .test-next {
          position: absolute;
          bottom: -20px;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          background: rgba(0,0,0,0.6);
          color: #d6a354;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: 0.3s;
          z-index: 10;
        }

        .test-prev {
          left: 0;
        }

        .test-next {
          left: 60px;
        }

        .test-prev:hover,
        .test-next:hover {
           background: rgba(0,0,0,0.8);
          
        }

        /* hide default swiper arrows */
        .swiper-button-prev,
        .swiper-button-next {
          display: none !important;
        }
      `}</style>

    </>
  );
};

export default Testimonial;